module.exports = __webpack_public_path__ + "static/media/placeholder-without-services.6805c557.svg";